<template>
  <div class="main-container">
    <div v-if="!formVisible && userinfo && userinfo.email !== ''">
      <p class="mobile">已绑定邮箱:
        <br/>
        <span>{{ userinfo.email }}</span>
      </p>
      <p v-if="userinfo.emailverify === 0">
        <span style="color: red;">您当前绑定的邮箱还未通过验证，请登录邮箱，点击验证链接！</span>
        <br />没有收到邮件？<a href="javascript:;" @click="resendmail">点此重新发送</a>
      </p>
      <p>邮箱是您身份的重要凭证。当帐号发生异常时，将会通过该邮箱第一时间通知到您</p> 
      <div style="padding: 16px;">
        <van-button round block type="primary" @click="showForm">
          更换邮箱
        </van-button>
      </div>
      <div style="padding: 16px;">
        <van-button round block @click="dounbindmail">
          解除绑定
        </van-button>
      </div>
    </div>
    <div v-else>
      <van-form @submit="onSubmit">
        <h2 v-if="userinfo && userinfo.email === ''">您还未绑定邮箱
        <br /> 强烈建议您立即绑定</h2>
        <van-field
          v-model="Form.email"
          clearable
          label="Email"
          placeholder="请输入邮箱地址"
          :rules="[{ required: true, pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请输入正确的邮箱地址' }]"
        />
        <div style="padding: 16px;">
          <van-button round block type="primary" native-type="submit">
            立即绑定
          </van-button>
        </div>
      </van-form>
    </div>
    
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import {
  SET_USERINFO
} from '@/store/mutation-types'
import { getUrlParams } from '../../utils/common'
import { Dialog } from 'vant'
export default {
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      formVisible: false,
      Form: {
        email: '',
      }
    }
  },
  computed: {
    ...mapGetters({
      secondVerifyState: 'user/secondVerifyState',
      userinfo: 'user/userinfo'
    })
  },
  methods: {
    showForm () {
      if (!this.secondVerifyState) {
        this.$router.push({ name: 'SecondConfirm', query: { redirect: window.location.href + '?action=bindnew' } })
      } else {
        this.formVisible = true
      }
    },
    onSubmit (formName) {
      this.$api.user.bindmail(this.Form)
        .then((res) => {
          if (res.data.code === 200) {
            this.$store.commit('user/' + SET_USERINFO, res.data.data)
            this.$router.push({ name: 'BindMail' })
            this.formVisible = false
          } else {
            this.$notify(res.data.message)
          }
        })
    },
    dounbindmail () {
      if (!this.secondVerifyState) {
        this.$router.push({ name: 'SecondConfirm', query: { redirect: window.location.href + '?action=unbindemail' } })
      } else {
        this.$router.replace({ name: 'BindMail', query: { action: 'unbindemail' } })
        Dialog.confirm({
          title: '解除绑定',
          message: '您确定要解除绑定的' + this.userinfo.email +'这个邮箱码？',
        })
          .then(() => {
            this.$api.user.unbindmail()
              .then((res) => {
                if (res.data.code === 200) {
                  this.$store.commit('user/' + SET_USERINFO, res.data.data)
                  this.$router.push({ name: 'BindMail' })
                } else {
                  this.$notify(res.data.message)
                }
              })
          })
          .catch(() => {
            return false
          })
      }
    },
    resendmail () {
      this.$api.user.resendmail()
        .then((res) => {
          if (res.data.code === 200) {
            this.$toast.success('重新发送激活邮件成功！')
          } else {
            this.$notify(res.data.message)
          }
        })
    }
  },
  created () {
    const action = getUrlParams('action')
    if (action === 'bindnew' ) {
      this.showForm()
    } else if (action === 'unbindemail') {
      this.dounbindmail()
    }
    this.$store.dispatch('user/UpdateUserinfo')
  }
}
</script>
<style scoped lang="less">
  .mobile{font-size: 20px;margin: 20px 0 20px 0;}
  .mobile span{display: inline-block; font-size: 36px;margin-top: 5px;}
</style>
